import { SafeStorage } from "../../../harmony/core";

export const safeLocalStorage = new SafeStorage(localStorage);
export const safeSessionStorage = new SafeStorage(sessionStorage);
